
import Posts from "../components/Posts";
import UserLayout from "../components/UserLayout";

const PostPage = () => {
    return (
        <UserLayout>
            <Posts />
        </UserLayout>
    );
}

export default PostPage;